export default "__VITE_ASSET__vvZLGJ$4__"